import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { interval } from 'rxjs';
import { StorageService } from './storage.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VersionHandlerService {
  private checkVersionIntervalMinutes;
  public isReloadVersion = false;
  private readonly frontVersionKey = 'Front-Version';
  private readonly isBrowser: boolean;
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private updates: SwUpdate,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.checkVersionIntervalMinutes = 120 * 60000;

    if (this.isBrowser && this.updates.isEnabled) {
      this.listenForSwUpdates();
    }
  }

  private listenForSwUpdates(): void {
    this.updates.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent =>
            event.type === 'VERSION_READY'
        )
      )
      .subscribe(() => {
        void this.forceUpdate();
      });
  }

  startIntervalHandleAppVersion() {
    interval(this.checkVersionIntervalMinutes).subscribe({
      next: () => {
        this.loadVersionConfigFromUri(() => {});
      },
    });
  }

  loadVersionConfigFromUri(callBack: () => void) {
    const url = `./version.json?v=${Date.now()}`;
    this.http
      .get(url, {
        headers: new HttpHeaders({
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        }),
      })
      .subscribe({
        next: (res) => {
          if (res['version']) {
            this.handleAppVersion(res['version']);
            const checkVersionInterval =
              +res['checkVersionIntervalMinutes'] * 60000;
            if (checkVersionInterval > 0) {
              this.checkVersionIntervalMinutes = checkVersionInterval;
            }
            callBack();
          }
        },
      });
  }

  private handleAppVersion(newFrontVersion: string) {
    if (!this.isBrowser) {
      return;
    }
    const oldFrontVersion = this.storageService.getFromLocalStorage(this.frontVersionKey);
    if (newFrontVersion) {
      if (newFrontVersion !== oldFrontVersion) {
        this.storageService.addToLocalStorage(this.frontVersionKey, newFrontVersion);
        void this.forceUpdate();
        //location.href = 'start';
      }
    }
  }

  private async forceUpdate(): Promise<void> {
    this.isReloadVersion = true;

    try {
      //localStorage.clear();
      this.storageService.clearAllUserStorageData();
      sessionStorage.clear();
    } catch {
    }

    try {
      if (this.updates.isEnabled) {
        await this.updates.activateUpdate();
      }
    } catch {
    }

    try {
      location.reload();
    } finally {
      this.isReloadVersion = false;
    }
  }
}
